import React from 'react';
import { ListItemText } from '@mui/material';
import { NavigationItemProps } from '../types';
import NavigationChildren from './NavigationChildren';
import NavigationIcon from './NavigationIcon';
import { ListItemContainer, ListIconContainer } from './styled';
import { RetoolPage } from '../constants/retoolPage';
import { fontSizes } from '../../../layouts/fontSizes';

const NavigationItem = ({
  navigationItem,
  open,
  openDropdown,
  handleDropdownToggle,
  selectedPage,
  setSelectedPage
}: NavigationItemProps) => {
  const navigationItemValue = String(navigationItem.value);
  const isSelected =
    selectedPage === navigationItemValue ||
    navigationItem.children?.some((child) => child.value === selectedPage);
  const hasChildren = Boolean(navigationItem.children);
  const isDropdownOpen = openDropdown[navigationItemValue];
  const isPageSupported = (value: string) => {
    return Object.values(RetoolPage).includes(value as RetoolPage);
  };
  const handleNavigationItemClick = () => {
    const isLeafNode =
      !navigationItem.children || navigationItem.children.length === 0;
    const isParent =
      navigationItem.children && isPageSupported(navigationItemValue);

    if (isLeafNode || isParent) {
      setSelectedPage(navigationItemValue);
    }
    // if (navigationItem.children?.length) {
    handleDropdownToggle(navigationItemValue);
    // }
  };

  return (
    <>
      <ListItemContainer
        onClick={handleNavigationItemClick}
        selected={isSelected}
        isOpened={isDropdownOpen}
      >
        <ListIconContainer selected={isSelected}>
          {isSelected
            ? navigationItem.icon?.filled && <navigationItem.icon.filled />
            : navigationItem.icon?.unfilled && <navigationItem.icon.unfilled />}
        </ListIconContainer>
        {open && (
          <ListItemText
            primary={navigationItem.title}
            primaryTypographyProps={{
              fontSize: isSelected ? fontSizes.h6 : fontSizes.default,
              fontWeight: isSelected ? 600 : 400,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineHeight: '1.5 !important'
            }}
            sx={{
              '& .MuiListItemText-primary': {
                transition: 'opacity 0.5s ease'
              }
            }}
          />
        )}
        {open && (
          <NavigationIcon
            hasChildren={hasChildren}
            isDropdownOpen={isDropdownOpen}
            isSelected={!!isSelected}
          />
        )}
      </ListItemContainer>
      {hasChildren && (
        <NavigationChildren
          childrenItems={navigationItem.children}
          isOpen={isDropdownOpen}
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
        />
      )}
    </>
  );
};

export default NavigationItem;
